import React, { ReactNode, createContext, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

import { Colors } from "Utils/colors";

type SnackType = "error" | "warning" | "success" | "info";
interface State {
  open: boolean;
  message: string;
  type: SnackType;
}

interface SnackBarContextInterface {
  snackbar: State;
  handleSnackbar: (visible: boolean, message: string, type?: SnackType) => void;
}
export const SnackBarContext = createContext<SnackBarContextInterface>(
  {} as SnackBarContextInterface
);

const SnackBarProvider = ({ children }: { children: ReactNode }) => {
  const [snackbar, setSnackbar] = useState<State>({
    open: false,
    message: "",
    type: "info",
  });

  const handleSnackbar = (
    visible: boolean,
    message: string = "",
    type: SnackType = "info"
  ) => {
    setSnackbar({ ...snackbar, message, type, open: visible });
  };

  return (
    <SnackBarContext.Provider
      value={{
        snackbar,
        handleSnackbar,
      }}
    >
      {children}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbar.open}
        onClose={() => handleSnackbar(false)}
        autoHideDuration={4500}
      >
        <Alert
          onClose={() => handleSnackbar(false)}
          severity={snackbar.type}
          sx={{
            width: "100%",
            backgroundColor: Colors.secondary,
            color: Colors.white,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackBarContext.Provider>
  );
};

export default SnackBarProvider;
